import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useAccountantClientDebt(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.accountantClientDebt(period),
    queryFn: () => dashboardApi.getAccountantClientDebt(period),
  });
}
